"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _models = require("~/models");
const _cli = require("~/cli");
const _catchError = require("~/helpers/catchError");
const _RowColorCondition = /*#__PURE__*/ _interop_require_default(require("~/models/RowColorCondition"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('getAst');
const getAst = async (context, { query, extractOnlyPrimaries = false, includePkByDefault = true, model, view, dependencyFields = _extends({}, query || {}, {
    nested: _extends({}, (query == null ? void 0 : query.nested) || {}),
    fieldsSet: new Set()
}), getHiddenColumn = (query == null ? void 0 : query['getHiddenColumn']) === 'true', throwErrorIfInvalidParams = false, extractOnlyRangeFields = false, apiVersion = _nocodbsdk.NcApiVersion.V2, extractOrderColumn = false, includeSortAndFilterColumns = false, includeRowColorColumns = false, includeButtonFilterColumns = false, skipSubstitutingColumnIds = false })=>{
    var _model_columns;
    // set default values of dependencyFields and nested
    dependencyFields.nested = dependencyFields.nested || {};
    dependencyFields.fieldsSet = dependencyFields.fieldsSet || new Set();
    const getFieldKey = (col)=>{
        return skipSubstitutingColumnIds ? col.id : col.title;
    };
    let coverImageId;
    let dependencyFieldsForCalenderView;
    let kanbanGroupColumnId;
    let sortColumnIds = [];
    let filterColumnIds = [];
    if (view && view.type === _nocodbsdk.ViewTypes.GALLERY) {
        const gallery = await _models.GalleryView.get(context, view.id);
        coverImageId = gallery.fk_cover_image_col_id;
    } else if (view && view.type === _nocodbsdk.ViewTypes.KANBAN) {
        const kanban = await _models.KanbanView.get(context, view.id);
        coverImageId = kanban.fk_cover_image_col_id;
        kanbanGroupColumnId = kanban.fk_grp_col_id;
    } else if (view && view.type === _nocodbsdk.ViewTypes.CALENDAR) {
        // const calendar = await CalendarView.get(view.id);
        // coverImageId = calendar.fk_cover_image_col_id;
        const calenderRanges = await _models.CalendarRange.read(context, view.id);
        if (calenderRanges) {
            dependencyFieldsForCalenderView = calenderRanges.ranges.flatMap((obj)=>[
                    obj.fk_from_column_id,
                    obj.fk_to_column_id
                ].filter(Boolean)).map(String);
        }
    }
    if (view && includeSortAndFilterColumns) {
        const sorts = await view.getSorts(context);
        const filters = await _models.Filter.allViewFilterList(context, {
            viewId: view.id
        });
        sortColumnIds = sorts.map((s)=>s.fk_column_id);
        filterColumnIds = filters.map((f)=>f.fk_column_id);
    }
    if (!((_model_columns = model.columns) == null ? void 0 : _model_columns.length)) await model.getColumns(context);
    if (includeSortAndFilterColumns) {
        const orderCol = model.columns.find((c)=>(0, _nocodbsdk.isOrderCol)(c));
        if (orderCol) {
            sortColumnIds.push(orderCol.id);
        }
    }
    const rowColoringColumnIds = new Set();
    if (view && includeRowColorColumns) {
        const addingColumns = await getViewRowColorFields({
            context,
            view
        });
        for (const addColumn of addingColumns){
            rowColoringColumnIds.add(addColumn);
        }
    }
    const buttonFilterColumnIds = new Set();
    if (view && includeButtonFilterColumns) {
        const addingColumns = await getButtonFilterFields({
            context,
            model,
            view
        });
        for (const addColumn of addingColumns){
            buttonFilterColumnIds.add(addColumn);
        }
    }
    // extract only pk and pv
    if (extractOnlyPrimaries) {
        const ast = _extends({}, model.primaryKeys ? model.primaryKeys.reduce((o, pk)=>_extends({}, o, {
                [getFieldKey(pk)]: 1
            }), {}) : {}, model.displayValue ? {
            [getFieldKey(model.displayValue)]: 1
        } : {});
        await Promise.all(model.primaryKeys.map((c)=>extractDependencies(context, c, dependencyFields)));
        await extractDependencies(context, model.displayValue, dependencyFields);
        return {
            ast,
            dependencyFields,
            parsedQuery: dependencyFields
        };
    }
    if (extractOnlyRangeFields) {
        const ast = _extends({}, (dependencyFieldsForCalenderView || []).reduce((o, f)=>{
            const col = model.columns.find((c)=>c.id === f);
            return _extends({}, o, {
                [getFieldKey(col)]: 1
            });
        }, {}));
        await Promise.all((dependencyFieldsForCalenderView || []).map((f)=>extractDependencies(context, model.columns.find((c)=>c.id === f), dependencyFields)));
        return {
            ast,
            dependencyFields,
            parsedQuery: dependencyFields
        };
    }
    let fields = (query == null ? void 0 : query.fields) || (query == null ? void 0 : query.f);
    if (fields && fields !== '*') {
        fields = Array.isArray(fields) ? fields : fields.split(',');
        if (throwErrorIfInvalidParams) {
            const colAliasMap = await model.getColAliasMapping(context);
            const aliasColMap = await model.getAliasColObjMap(context);
            const invalidFields = fields.filter((f)=>!colAliasMap[f] && !aliasColMap[f]);
            if (invalidFields.length) {
                _catchError.NcError.get(context).fieldNotFound(invalidFields.join(', '));
            }
        }
    } else {
        fields = null;
    }
    let allowedCols = null;
    if (view) {
        allowedCols = (await _models.View.getColumns(context, view.id)).reduce((o, c)=>_extends({}, o, {
                [c.fk_column_id]: c.show || c instanceof _models.GridViewColumn && c.group_by || c instanceof _models.KanbanViewColumn && c.fk_column_id === kanbanGroupColumnId
            }), {});
        if (coverImageId) {
            allowedCols[coverImageId] = 1;
        }
        if (dependencyFieldsForCalenderView) {
            dependencyFieldsForCalenderView.forEach((id)=>{
                allowedCols[id] = 1;
            });
        }
        if (includeSortAndFilterColumns) {
            sortColumnIds.forEach((id)=>allowedCols[id] = 1);
            filterColumnIds.forEach((id)=>allowedCols[id] = 1);
        }
    }
    const columns = model.columns;
    const ast = {};
    for (const col of columns){
        var _query_nested_col_title, _query_nested, _query_nested_col_title1, _query_nested1;
        let value = 1;
        // TODO: also get from col.id
        const nestedFields = (query == null ? void 0 : (_query_nested = query.nested) == null ? void 0 : (_query_nested_col_title = _query_nested[col.title]) == null ? void 0 : _query_nested_col_title.fields) || (query == null ? void 0 : (_query_nested1 = query.nested) == null ? void 0 : (_query_nested_col_title1 = _query_nested1[col.title]) == null ? void 0 : _query_nested_col_title1.f);
        const linksAsLtar = (query == null ? void 0 : query.linksAsLtar) === 'true';
        if (nestedFields && nestedFields !== '*') {
            if (col.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord || col.uidt === _nocodbsdk.UITypes.Links && linksAsLtar) {
                var _query_nested2;
                const colOpt = await col.getColOptions(context);
                const model = await colOpt.getRelatedTable(context);
                if (!model) {
                    // Skip this column - related table not found
                    // This allows data retrieval to continue even with broken relations
                    logger.warn(`Skipping column ${col.title}: related table ${colOpt.fk_related_model_id} not found`);
                    ast[getFieldKey(col)] = null;
                    continue;
                }
                const { refContext: refTableContext } = colOpt.getRelContext(context);
                const { ast: childAst } = await getAst(refTableContext, {
                    model,
                    query: query == null ? void 0 : (_query_nested2 = query.nested) == null ? void 0 : _query_nested2[col.title],
                    dependencyFields: dependencyFields.nested[col.title] = dependencyFields.nested[col.title] || {
                        nested: {},
                        fieldsSet: new Set()
                    },
                    throwErrorIfInvalidParams
                });
                value = childAst;
            // todo: include field relative to the relation => pk / fk
            } else if (col.uidt === _nocodbsdk.UITypes.Links) {
                value = 1;
            } else {
                value = (Array.isArray(nestedFields) ? nestedFields : nestedFields.split(',')).reduce((o, f)=>_extends({}, o, {
                        [f]: 1
                    }), {});
            }
        } else if (col.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord || col.uidt === _nocodbsdk.UITypes.Links && linksAsLtar) {
            var _query_nested3;
            const colOpt = await col.getColOptions(context);
            const { refContext: refTableContext } = colOpt.getRelContext(context);
            const model = await colOpt.getRelatedTable(context);
            if (!model) {
                // Skip this column - related table not found
                // This allows data retrieval to continue even with broken relations
                logger.warn(`Skipping column ${col.title}: related table ${colOpt.fk_related_model_id} not found`);
                ast[getFieldKey(col)] = null;
                continue;
            }
            value = (await getAst(refTableContext, {
                model,
                query: query == null ? void 0 : (_query_nested3 = query.nested) == null ? void 0 : _query_nested3[col.title],
                extractOnlyPrimaries: nestedFields !== '*',
                dependencyFields: dependencyFields.nested[col.title] = dependencyFields.nested[col.title] || {
                    nested: {},
                    fieldsSet: new Set()
                },
                throwErrorIfInvalidParams
            })).ast;
        }
        let isRequested;
        const isInFields = (fields == null ? void 0 : fields.length) && (fields.includes(col.title) || fields.includes(col.id));
        const isSortOrFilterColumn = includeSortAndFilterColumns && (sortColumnIds.includes(col.id) || filterColumnIds.includes(col.id));
        // exclude row meta column
        if (col.uidt === _nocodbsdk.UITypes.Meta) {
            isRequested = false;
        } else if (isSortOrFilterColumn) {
            isRequested = true;
        } else if (rowColoringColumnIds.has(col.id) || buttonFilterColumnIds.has(col.id)) {
            isRequested = true;
        } else if (col.system && ![
            _nocodbsdk.UITypes.CreatedTime,
            _nocodbsdk.UITypes.LastModifiedTime
        ].includes(col.uidt) && apiVersion === _nocodbsdk.NcApiVersion.V3) {
            isRequested = false;
        } else if ((0, _nocodbsdk.isCreatedOrLastModifiedByCol)(col) && col.system) {
            isRequested = false;
        } else if ((0, _nocodbsdk.isOrderCol)(col) && col.system) {
            isRequested = extractOrderColumn || getHiddenColumn;
        } else if (getHiddenColumn) {
            var _col_colOptions;
            isRequested = !(0, _nocodbsdk.isSystemColumn)(col) || (!view || !!(view == null ? void 0 : view.show_system_fields)) && !(0, _nocodbsdk.isHiddenCol)(col, model) || (0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(col) && col.system || // include all non-has-many system links(self-link) columns since has-many is part of mm relation and which is not required
            (0, _nocodbsdk.isLinksOrLTAR)(col) && col.system && [
                _nocodbsdk.RelationTypes.BELONGS_TO,
                _nocodbsdk.RelationTypes.MANY_TO_MANY,
                _nocodbsdk.RelationTypes.ONE_TO_ONE
            ].includes((_col_colOptions = col.colOptions) == null ? void 0 : _col_colOptions.type) || col.pk;
        } else if (allowedCols && (!includePkByDefault || !col.pk)) {
            isRequested = allowedCols[col.id] && (!(0, _nocodbsdk.isSystemColumn)(col) || !view && (0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(col) || view.show_system_fields || (dependencyFieldsForCalenderView != null ? dependencyFieldsForCalenderView : []).includes(col.id) || col.pv) && (!(fields == null ? void 0 : fields.length) || isInFields) && value;
        } else if (fields == null ? void 0 : fields.length) {
            // For APIv3, always extract primary key dependencies even if not explicitly requested
            // This is needed because APIv3 always returns the primary key as 'id' at root level
            isRequested = isInFields && value || apiVersion === _nocodbsdk.NcApiVersion.V3 && col.pk;
        } else {
            isRequested = value;
        }
        if (isRequested || col.pk) await extractDependencies(context, col, dependencyFields);
        ast[getFieldKey(col)] = isRequested;
    }
    return {
        ast,
        dependencyFields,
        parsedQuery: dependencyFields
    };
};
const getViewRowColorFields = async (params)=>{
    if (params.view.row_coloring_mode === _nocodbsdk.ROW_COLORING_MODE.SELECT) {
        var _viewMeta_rowColoringInfo;
        const viewMeta = (0, _nocodbsdk.parseProp)(params.view.meta);
        return [
            viewMeta == null ? void 0 : (_viewMeta_rowColoringInfo = viewMeta.rowColoringInfo) == null ? void 0 : _viewMeta_rowColoringInfo.fk_column_id
        ];
    } else if (params.view.row_coloring_mode === _nocodbsdk.ROW_COLORING_MODE.FILTER) {
        var _params_ncMeta;
        const ncMeta = (_params_ncMeta = params.ncMeta) != null ? _params_ncMeta : _Noco.default.ncMeta;
        const rowColorConditions = await _RowColorCondition.default.getByViewId(params.context, params.view.id);
        const filters = await ncMeta.metaList2(params.context.workspace_id, params.context.base_id, _cli.MetaTable.FILTER_EXP, {
            xcCondition: (knex)=>knex.whereIn('fk_row_color_condition_id', rowColorConditions.map((k)=>k.id))
        });
        return filters.filter((f)=>f.fk_column_id).map((f)=>f.fk_column_id).filter((value, index, array)=>array.indexOf(value) === index);
    }
    return [];
};
/**
 * Returns the column IDs referenced by button visibility filters across all
 * button columns in the table.  This ensures hidden columns used in button
 * filter conditions are still included in the API response.
 */ const getButtonFilterFields = async (params)=>{
    var _params_ncMeta;
    var _params_model_columns;
    const ncMeta = (_params_ncMeta = params.ncMeta) != null ? _params_ncMeta : _Noco.default.ncMeta;
    // Find all button columns in this table
    if (!((_params_model_columns = params.model.columns) == null ? void 0 : _params_model_columns.length)) await params.model.getColumns(params.context);
    let buttonColIds = params.model.columns.filter((col)=>col.uidt === _nocodbsdk.UITypes.Button).map((col)=>col.id);
    // If a view is provided, only include button columns visible in the view
    if (params.view && buttonColIds.length) {
        const viewColumns = await _models.View.getColumns(params.context, params.view.id);
        const visibleColIds = new Set(viewColumns.filter((vc)=>vc.show).map((vc)=>vc.fk_column_id));
        buttonColIds = buttonColIds.filter((id)=>visibleColIds.has(id));
    }
    if (!buttonColIds.length) return [];
    // Fetch all filters that belong to these button columns
    const filters = await ncMeta.metaList2(params.context.workspace_id, params.context.base_id, _cli.MetaTable.FILTER_EXP, {
        xcCondition: (knex)=>knex.whereIn('fk_button_col_id', buttonColIds)
    });
    return filters.filter((f)=>f.fk_column_id).map((f)=>f.fk_column_id).filter((value, index, array)=>array.indexOf(value) === index);
};
const extractDependencies = async (context, column, dependencyFields = {
    nested: {},
    fieldsSet: new Set()
})=>{
    switch(column == null ? void 0 : column.uidt){
        case _nocodbsdk.UITypes.Lookup:
            await extractLookupDependencies(context, column, dependencyFields);
            break;
        case _nocodbsdk.UITypes.LinkToAnotherRecord:
            await extractRelationDependencies(context, column, dependencyFields);
            break;
        default:
            dependencyFields.fieldsSet.add(column.title);
            break;
    }
};
const extractLookupDependencies = async (context, lookUpColumn, dependencyFields = {
    nested: {},
    fieldsSet: new Set()
})=>{
    const lookupColumnOpts = await lookUpColumn.getColOptions(context);
    const relationColumn = await lookupColumnOpts.getRelationColumn(context);
    const relationColumnOpts = await relationColumn.getColOptions(context);
    const { refContext } = relationColumnOpts.getRelContext(context);
    await extractRelationDependencies(context, relationColumn, dependencyFields);
    await extractDependencies(refContext, await lookupColumnOpts.getLookupColumn(refContext), dependencyFields.nested[relationColumn.title] = dependencyFields.nested[relationColumn.title] || {
        nested: {},
        fieldsSet: new Set()
    });
};
const extractRelationDependencies = async (context, relationColumn, dependencyFields = {
    nested: {},
    fieldsSet: new Set()
})=>{
    const relationColumnOpts = await relationColumn.getColOptions(context);
    switch(relationColumnOpts.type){
        case _nocodbsdk.RelationTypes.HAS_MANY:
            dependencyFields.fieldsSet.add(await relationColumnOpts.getParentColumn(context).then((col)=>col.title));
            break;
        case _nocodbsdk.RelationTypes.BELONGS_TO:
        case _nocodbsdk.RelationTypes.MANY_TO_MANY:
            dependencyFields.fieldsSet.add(await relationColumnOpts.getChildColumn(context).then((col)=>col.title));
            break;
        case _nocodbsdk.RelationTypes.ONE_TO_ONE:
            var _relationColumn_meta;
            if ((_relationColumn_meta = relationColumn.meta) == null ? void 0 : _relationColumn_meta.bt) {
                dependencyFields.fieldsSet.add(await relationColumnOpts.getChildColumn(context).then((col)=>col.title));
            } else {
                dependencyFields.fieldsSet.add(await relationColumnOpts.getParentColumn(context).then((col)=>col.title));
            }
            break;
    }
};
const _default = getAst;
